import RowFieldTemplate from "./RowFieldTemplate";

export default RowFieldTemplate;